<template>
  <div class="w-100">
    <img src="@/assets/images/train_cover.jpg" class="w-100">
    <br>
    <br>
    <div v-html="getCaption('caption.train_schedule_content')"></div>
  </div>
</template>

<script>
import { transportationSchedule } from "@/constants/sidemenu.js";

export default {
  mounted() {
    this.setSidemenu();
  },

  methods: {
    setSidemenu() {
      this.$store.dispatch("setSidemenuData", {
        menu: transportationSchedule,
        parentType: "topmenu"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  color: blue;
}
</style>
